import React, { Component } from 'react'

export default class PlaceHolder extends Component {
    render() {
        return (
            <div>
                Please Select Favorite 
            </div>
        )
    }
}
